/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Unknown_SkuInputs */

const en_po_issue_unknown_sku = /** @type {(inputs: Po_Issue_Unknown_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is not a SKU of the brand you can see`)
};

/**
* | output |
* | --- |
* | "is not a SKU of the brand you can see" |
*
* @param {Po_Issue_Unknown_SkuInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_unknown_sku = /** @type {((inputs?: Po_Issue_Unknown_SkuInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Unknown_SkuInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_unknown_sku(inputs)
});